import script from "./MessageCenterBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageCenterBase.vue?vue&type=script&setup=true&lang=ts"

import "./MessageCenterBase.vue?vue&type=style&index=0&id=01c48b0a&lang=scss"

const __exports__ = script;

export default __exports__